import JwtService from "../core/backend/jwt.service";

export default function (to, from, next) {
    if(JwtService.hasToken()) {
        return next('/app');
    }
    return next();
}
